(function ($) {
	// DEBUG TOGGLE - Set to true to enable verbose logging
	var DEBUG_MODE = false;
	var LOG_PREFIX = '[BOLD_DEBUG]';
	
	function debugLog(message, data) {
		if (DEBUG_MODE) {
			if (data !== undefined) {
				console.log(LOG_PREFIX + ' ' + message, data);
			} else {
				console.log(LOG_PREFIX + ' ' + message);
			}
		}
	}
	
	debugLog('External.js loaded - setting up BOLD event listener');
	
	// Listen for BOLD OPTIONS to be loaded instead of document.ready
	if (window.BOLD && BOLD.common && BOLD.common.eventEmitter) {
		debugLog('BOLD is already available, adding listener immediately');
		setupBoldListener();
	} else {
		debugLog('BOLD not yet available, waiting...');
		// Poll for BOLD to become available
		var boldCheckInterval = setInterval(function() {
			if (window.BOLD && BOLD.common && BOLD.common.eventEmitter) {
				debugLog('BOLD is now available');
				clearInterval(boldCheckInterval);
				setupBoldListener();
			}
		}, 100);
	}
	
	function setupBoldListener() {
		debugLog('Setting up BOLD_OPTIONS_options_loaded listener');
		BOLD.common.eventEmitter.on('BOLD_OPTIONS_options_loaded', function() {
			debugLog('BOLD_OPTIONS_options_loaded event fired - initializing');
			initializeBoldOptions();
		});
	}
	
	function initializeBoldOptions() {
		debugLog('initializeBoldOptions() called');
		debugLog('Checking for .bold_options element:', $('.bold_options').length);
		
		function load_bold_options() {
			debugLog('load_bold_options() called');
			debugLog('.bold_options has class bold_options_loaded:', $('.bold_options').hasClass('bold_options_loaded'));
			debugLog('#radio1 has class option1:', $('#radio1').hasClass('option1'));
			
			if ($('.bold_options').hasClass('bold_options_loaded') && !$('#radio1').hasClass('option1')) {
				debugLog('Condition met - processing bold options');
				
				var radio=0
				var text=0
				var dropdown=0
				var checkbox=0
				var col1=''
				var col2=''
				
				debugLog('Found .bold_option elements:', $('.bold_options > .bold_option_set .bold_option').length);
				
				$('.bold_options > .bold_option_set .bold_option').each(function (key,element) {
					var option='option'+(key+1)
					$(element).addClass(option)
					debugLog('Processing element ' + (key+1) + ' with option class: ' + option);
					
					if ($(element).hasClass('bold_option_radio')) {
						$(element).addClass('ck-col-1')
						radio+=1
						$(element).attr('id','radio'+radio)
						debugLog('Added radio' + radio + ' id to element');
					}
					if ($(element).hasClass('bold_option_displaytext')) {
						$(element).addClass('ck-col-2')
						text+=1
						$(element).attr('id','text'+text)
						debugLog('Added text' + text + ' id to element');

						// to change ul to ol
						// var id=$(element).attr('id')
						var html_old=$(element).html()
						var html_new=html_old.replace('ul','ol')
						$(element).html(html_new)
						debugLog('Replaced ul with ol in text element');
					}
					if ($(element).hasClass('bold_option_dropdown')) {
						$(element).addClass('ck-col-1')
						dropdown+=1
						$(element).attr('id','dropdown'+dropdown)
						debugLog('Added dropdown' + dropdown + ' id to element');
					}
					if ($(element).hasClass('bold_option_checkbox')) {
						$(element).addClass('ck-col-2')
						checkbox+=1
						$(element).attr('id','checkbox'+dropdown)
						debugLog('Added checkbox' + dropdown + ' id to element');
					}
				})
				
				debugLog('Checking for #radio1.option1 checked input');
				$('#radio1.option1 input:checked').closest('.bold_option_value').addClass('radioSelected')
				$('#radio1.option1 input:checked').closest('.bold_option_element').addClass('radio1Selected')
				debugLog('Applied radioSelected classes');

				// $('#text4.option9,#text3.option8').removeClass("ck-col-2").addClass('ck-col-1')
				$('.bold_option_set').prepend('<div class="ck-col-2 order_overview">Order Overview</div>')
				debugLog('Prepended Order Overview div');
			} else {
				debugLog('Condition NOT met - skipping bold options processing');
			}
		  	window.setTimeout(load_bold_options, 1000); 
			debugLog('Scheduled load_bold_options to run again in 1000ms');
		}
		
		load_bold_options();
		
		debugLog('Setting up click handler for .custom_search_form .input-group');
		$('.custom_search_form .input-group').click(function () {
			debugLog('Search form clicked');
			$('.nt_search_full-screen a').click()
			// $('body').addClass('open_search')
		})
		
		debugLog('Setting up click handler for .expand-button');
		$('.expand-button').on('click',function () {
			var btn=$(this)
			debugLog('Expand button clicked:', btn);
			btn.siblings('.hidden-step-content').slideToggle('slow');
		})
		
		// update price above submit btn
		debugLog('Initial price update');
		update_price($('#product_price p.productPrice').text(),$('.bold_option_total  > div span').html())
	}
	
	function update_price(html1,html2) {
		debugLog('update_price() called with:', {html1: html1, html2: html2});
		
		html1=html1==undefined || html1=='' || html1==null ? '0.00' : html1;
		html2=html2==undefined || html2=='' || html2==null ? '0.00' : html2;
		
		var regex = /[+-]?\d+(\.\d+)?/g;  
		html1 = html1.match(regex).map(function(v) { return parseFloat(v); });;
		html2 = html2.match(regex).map(function(v) { return parseFloat(v); });;
		
		debugLog('Parsed prices:', {html1: html1, html2: html2});
		
		var currency=$('#custom_currency').html()
		total=parseFloat(html1[0]+html2[0])
		
		debugLog('Calculated total:', total);
		debugLog('Currency:', currency);
		
		$('#custom_price').html(currency+total)
		debugLog('Updated #custom_price with:', currency+total);
	}
	
	debugLog('Setting up change handler for #radio1.option1 input');
	$('.bold_options').on('change','#radio1.option1 input',function () {
		debugLog('#radio1.option1 input changed');
		var radio=$(this)
		radio1_change(radio)
	})
	
	function radio1_change(radio) {
		var value=radio.val()
		debugLog('radio1_change() called with value:', value);
		
		$('#radio1.option1 input').closest('.bold_option_value').removeClass('radioSelected')
		$('#radio1.option1 input').closest('.bold_option_element').removeClass('radio1Selected radio2Selected radio3Selected')
		
		if (value.indexOf('Walk')!= -1) {
			debugLog('Value contains "Walk" - adding radio1Selected');
			radio.closest('.bold_option_element').addClass('radio1Selected')
		}
		if (value.indexOf('Mail')!= -1) {
			debugLog('Value contains "Mail" - adding radio2Selected');
			radio.closest('.bold_option_element').addClass('radio2Selected')
		}
		if (value.indexOf('Courier')!= -1) {
			debugLog('Value contains "Courier" - adding radio3Selected');
			radio.closest('.bold_option_element').addClass('radio3Selected')
		}
		radio.closest('.bold_option_value').addClass('radioSelected')
		debugLog('Applied radioSelected class');
	}
	
	debugLog('Setting up change handler for #radio2');
	$('.bold_options').on('change','#radio2',function () {
		debugLog('#radio2 changed');
		$('.bold_options > .bold_option_set .bold_option').each(function (key,element) {
			if ($(element).hasClass('bold_option_displaytext')) {
				var id=$(element).attr('id')
				if ($('#'+id+' iframe').length > 0) {
					debugLog('Found iframe in ' + id + ' - changing column class');
					$(element).removeClass("ck-col-2").addClass('ck-col-1')
				}
			}
		})
	})
	
	// just to change ul to ol & change price
	debugLog('Setting up change handler for radio/dropdown elements');
	$('.bold_options').on('change','#radio2,#radio1,#radio3,#radio4,#radio5,#dropdown1,#dropdown2,#dropdown3,#dropdown4,#dropdown5',function () {
		debugLog('Radio or dropdown changed:', $(this).attr('id'));
		
		$('.bold_options > .bold_option_set .bold_option').each(function (key,element) {
			if ($(element).hasClass('bold_option_displaytext')) {
				var id=$(element).attr('id')
				var html_old=$('#'+id).html()
				var html_new=html_old.replace('ul','ol')
				$('#'+id).html(html_new)
			}
		})
		debugLog('Replaced ul with ol in displaytext elements');
		
		// update price above submit btn
		debugLog('Updating price after change');
		update_price($('#product_price p.productPrice').text(),$('.bold_option_total  > div span').html())
	})
})(jQuery)